"use strict";

import { Navigation } from 'swiper/modules';

const EDGE_PX = 2;
const PREV_SELECTOR = '.carousel-nav-prev';
const NEXT_SELECTOR = '.carousel-nav-next';
const preferPrevByEl = new WeakMap();

function getEdgeState(swiper) {
	if (!swiper || swiper.destroyed) {
		return { locked: true, atStart: true, atEnd: true };
	}

	const min = swiper.minTranslate();
	const max = swiper.maxTranslate();
	const current = swiper.getTranslate();
	const locked = Boolean(swiper.isLocked) || max >= min - EDGE_PX;

	return {
		locked,
		atStart: locked || current >= min - EDGE_PX,
		atEnd: locked || current <= max + EDGE_PX,
	};
}

export function syncCarouselNavVisibility(swiper) {
	const el = swiper?.el;

	if (!el) {
		return;
	}

	const prev = el.querySelector(PREV_SELECTOR);
	const next = el.querySelector(NEXT_SELECTOR);
	const { locked, atStart, atEnd } = getEdgeState(swiper);

	// Sticky: a fine corsa resta la freccia sinistra finché non si torna all'inizio.
	let preferPrev = Boolean(preferPrevByEl.get(el));

	if (locked) {
		preferPrev = false;
	} else if (atEnd) {
		preferPrev = true;
	} else if (atStart) {
		preferPrev = false;
	}

	preferPrevByEl.set(el, preferPrev);

	const showPrev = !locked && preferPrev;
	const showNext = !locked && !preferPrev;

	if (prev) {
		prev.classList.toggle('is-visible', showPrev);
		prev.setAttribute('aria-hidden', showPrev ? 'false' : 'true');
		prev.tabIndex = showPrev ? 0 : -1;
	}

	if (next) {
		next.classList.toggle('is-visible', showNext);
		next.setAttribute('aria-hidden', showNext ? 'false' : 'true');
		next.tabIndex = showNext ? 0 : -1;
	}
}

/**
 * Arricchisce le opzioni Swiper con Navigation e sync visibilità frecce.
 */
export function withCarouselNav(el, options = {}) {
	const prevEl = el.querySelector(PREV_SELECTOR);
	const nextEl = el.querySelector(NEXT_SELECTOR);
	const userOn = options.on || {};
	const modules = Array.isArray(options.modules) ? options.modules.slice() : [];

	if (!modules.includes(Navigation)) {
		modules.push(Navigation);
	}

	const wrap = function (handler) {
		return function (swiper) {
			if (typeof handler === 'function') {
				handler.apply(this, arguments);
			}

			syncCarouselNavVisibility(swiper);
		};
	};

	return {
		...options,
		modules,
		watchOverflow: options.watchOverflow !== false,
		navigation: {
			prevEl: prevEl || undefined,
			nextEl: nextEl || undefined,
		},
		on: {
			...userOn,
			init: wrap(userOn.init),
			slideChange: wrap(userOn.slideChange),
			reachBeginning: wrap(userOn.reachBeginning),
			reachEnd: wrap(userOn.reachEnd),
			fromEdge: wrap(userOn.fromEdge),
			progress: wrap(userOn.progress),
			setTranslate: wrap(userOn.setTranslate),
			touchEnd: wrap(userOn.touchEnd),
			transitionEnd: wrap(userOn.transitionEnd),
			resize: wrap(userOn.resize),
			update: wrap(userOn.update),
			lock: wrap(userOn.lock),
			unlock: wrap(userOn.unlock),
		},
	};
}
